// extracted by mini-css-extract-plugin
module.exports = {"red":"analysis_red__2Js-f","green":"analysis_green__1IlJE"};